module.exports = __webpack_public_path__ + "static/media/Project1_Fig3.d58f4f93.svg";